<template>

<form class="item-editor-form">

    <b-row>
        <b-col>
            <SelectList 
                :label="$t('timetables.mode')" 
                :options="modeOptions" 
                :value="form.DISPLAY_STATE" 
                @select="onSelectMode" 
                :searchable="false" 
                :clearable="false" 
                :disabled="loading"/> 
        </b-col>
         <b-col>
            <SelectList 
                :label="$t('timetables.rt.h')" 
                :options="rtOptions" 
                :value="form.DISPLAY_REALTIME_DATA_ENABLED" 
                @select="onSelectRt" 
                :searchable="false" 
                :clearable="false" 
                :disabled="loading"/> 
         </b-col>
     </b-row>
  
    <hr>

    <label>{{ $t('timetables.h.h') }}</label>
    <fg-input v-model="form.DISPLAY_H1_1" :label="$t('timetables.h.1')" :disabled="loading"></fg-input>
    <fg-input v-model="form.DISPLAY_H1_2" :label="$t('timetables.h.2')" :disabled="loading"></fg-input>
    <fg-input v-model="form.DISPLAY_H1_3" :label="$t('timetables.h.3')" :disabled="loading"></fg-input>
  
    <!--
     <FormButtons
        @submit="submit" 
        :reset="false" 
        :remove="false" 
        :disableSubmit="!selectionsChanged || loading"
         />
    -->
    <t-button-group>
        <t-button type="save" @click="save" :disabled="!selectionsChanged || loading"></t-button> 
    </t-button-group>

    <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />
</form>

</template>

<script>

export default {
    props: {
        item: { default: null }
    },
    data: function() {
        return  {
            disabled: false,
            form: {},
            settings: {},
            OK: false,
            ERROR: false,
            loading: false,
            modeOptions: [
                { id: '1', label: this.$t('timetables.modes.NORMAL'), icon: 'filter-square', variant: "success" },
                { id: '2', label: this.$t('timetables.modes.ONLY_INFO'), icon: 'info-square', variant: "info" },
                { id: '0', label: this.$t('timetables.modes.BLANK'), icon: 'square-fill' }
            ],
            rtOptions: [
                { id: '1', label: this.$t('timetables.rt.on'), icon: 'clock', variant: "success" },
                { id: '0', label: this.$t('timetables.rt.off'), icon: 'x-circle', variant: "dark" },
            ]
        }
    },
    computed: {
        selectionsChanged() {
            return (this.form.DISPLAY_STATE != this.settings.DISPLAY_STATE)
                || (this.form.DISPLAY_REALTIME_DATA_ENABLED != this.settings.DISPLAY_REALTIME_DATA_ENABLED)
                || (this.form.DISPLAY_H1_1 != this.settings.DISPLAY_H1_1)
                || (this.form.DISPLAY_H1_2 != this.settings.DISPLAY_H1_2) 
                || (this.form.DISPLAY_H1_3 != this.settings.DISPLAY_H1_3);
        }
    },
    watch: {
        item(){
          this.getTimetableViewSettings();
          //alert("cahnge")
        }
    },
    created(){
        this.getTimetableViewSettings();
    },
    methods: {
        getTimetableViewSettings(){
            this.loading = true;
            if(this.item){
                this.$traveller_http.get('/traveller/restui/content/timetableview/settings', { params: { "id": this.item.id} })
                .then( response => {
                    this.settings = response.data.settings;
                    this.form = JSON.parse(JSON.stringify(this.settings))
                    //this.form.DISPLAY_REALTIME_DATA_ENABLED = this.form.DISPLAY_REALTIME_DATA_ENABLED == "1";

                    //console.log( response.data );
                 })
                .catch( () => {} ) 
                .finally( () => { this.loading = false; } ); 
            }
        },
        onSelectMode(id) {
            this.form.DISPLAY_STATE = id;
        },
        onSelectRt(id) {
            this.form.DISPLAY_REALTIME_DATA_ENABLED = id;
        },
        getFormData(){
            var data = {};
            data.displayId = this.item.id;
            data.settings = this.form;
            return data;
        },
        save() {
            //console.log( this.getFormData() );
            this.OK = this.ERROR = false;
            this.loading = true;

            this.$store.dispatch('timetableview/saveSettings', this.getFormData() ).then(response => {
                this.OK = response.data.errorCode == 0;
                this.ERROR = !this.OK;
                this.settings = JSON.parse(JSON.stringify(this.form))
            })
            .catch( () => { this.OK = true; }) 
            .finally(() => { this.loading = false; })

        }
    }
}
</script>
